import { clear, del, delMany, get, set } from 'idb-keyval';

export const getStorageItem = async <T>(key: string) => {
  const item = await get<string>(key);
  if (item === null || item === undefined) {
    return null;
  }
  const obj = JSON.parse(item);
  parseDates(obj);
  return obj as T;
};
export const setStorageItem = (key: string, value: unknown) => {
  return set(key, value !== null && value !== undefined ? JSON.stringify(value) : null);
};
export const removeStorageItem = (key: string) => {
  return del(key);
};
export const clearStorage = (keys?: string[]) => {
  if (!keys) {
    return clear();
  }
  return delMany(keys);
};
const parseDates = (obj: unknown) => {
  Object.keys(obj).forEach(key => {
    const value = obj[key];
    if (value !== null && typeof value === 'object') {
      parseDates(value);
    } else if (value != null && typeof value === 'string') {
      // Check if the value is a date string (ISO 8601 format)
      const format = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;
      if (format.test(value)) {
        const date = new Date(value);
        if (date.toString() !== 'Invalid Date') {
          obj[key] = date;
        }
      }
    }
  });
};
